import {Injector} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {KeycloakService} from 'keycloak-angular';
import {LanguagesClient} from '@tech/api-clients/modules';
import {lastValueFrom} from 'rxjs';

// Environment
import {environment} from '@environments/environment';

export function initializeKeycloak(keycloak: KeycloakService, injector: Injector): () => Promise<boolean> {
  return async () => {
    const authenticated = await keycloak.init(
      {
        config: {
          url: environment.keycloak.url,
          realm: environment.keycloak.realm,
          clientId: environment.keycloak.clientId,
        },
        initOptions: {
          onLoad: 'login-required',
          checkLoginIframe: true
        },
        bearerExcludedUrls: []
      }
    );
    // Locales are registered here and not in their own APP_INITIALIZER: initializers run in parallel and the
    // Languages request was sent before Keycloak init, without the token
    await registerLanguagesLocales(injector.get(LanguagesClient));
    return authenticated;
  };
}

/**
 * Registers the Angular locale data of the languages returned by the Modules API.
 *
 * @param languagesClient LanguagesClient
 */
async function registerLanguagesLocales(languagesClient: LanguagesClient): Promise<void> {
  const languages = await lastValueFrom(languagesClient.getLanguages());

  for (const l of languages) {
    if (l.localeCode) {
      const locale = await import(
        `../../../../node_modules/@angular/common/locales/${l.localeCode}.mjs`);
      registerLocaleData(locale.default);
    }
  }
}
